const DEFAULT_ERROR_MESSAGE = 'Er ging iets mis. Probeer het opnieuw.';

function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || '';
}

function extractErrorMessage(data, fallback = DEFAULT_ERROR_MESSAGE) {
    if (data?.message) {
        return data.message;
    }

    if (data?.errors && typeof data.errors === 'object') {
        const firstError = Object.values(data.errors)
            .flat()
            .find(Boolean);

        if (firstError) {
            return firstError;
        }
    }

    return fallback;
}

async function readResponse(response) {
    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
        try {
            return await response.json();
        } catch (error) {
            return null;
        }
    }

    try {
        const text = await response.text();

        return text
            ? { message: text }
            : null;
    } catch (error) {
        return null;
    }
}

export async function postJson(url, payload) {
    let response;

    try {
        response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': getCsrfToken(),
            },
            body: JSON.stringify(payload),
        });
    } catch (error) {
        throw new Error(
            'De verbinding met de webshop is mislukt. Controleer je internetverbinding en probeer het opnieuw.'
        );
    }

    const data = await readResponse(response);

    if (!response.ok) {
        throw new Error(extractErrorMessage(data));
    }

    /*
     * CartController returns HTTP 200 with success:false for business-rule
     * failures such as insufficient stock or a maximum purchase limit.
     */
    if (data?.success === false) {
        throw new Error(
            extractErrorMessage(
                data,
                'Deze actie kon niet worden uitgevoerd.'
            )
        );
    }

    return data || { success: true };
}

export function normaliseError(error) {
    return error instanceof Error
        ? error.message
        : DEFAULT_ERROR_MESSAGE;
}